import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-xl-row" }
const _hoisted_2 = { class: "flex-column flex-lg-row-auto w-100" }
const _hoisted_3 = { class: "card mb-5" }
const _hoisted_4 = { class: "card-body pt-3 pb-0" }
const _hoisted_5 = { class: "d-flex flex-stack" }
const _hoisted_6 = {
  class: "fw-bolder fs-6 text-gray-600 text-uppercase rotate collapsible",
  "data-bs-toggle": "collapse",
  href: "#kt_customer_view_details",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "kt_customer_view_details"
}
const _hoisted_7 = { class: "ms-2 rotate-180" }
const _hoisted_8 = { class: "svg-icon svg-icon-3" }
const _hoisted_9 = { class: "badge badge-light-primary m-auto" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-1" }, null, -1)
const _hoisted_11 = {
  id: "kt_customer_view_details",
  class: "collapse show"
}
const _hoisted_12 = { class: "py-2 fs-6" }
const _hoisted_13 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-normal min-w-120px flex-shrink-0" }, "CMND/CCCD:", -1)
const _hoisted_15 = { class: "fw-semibold text-gray-800" }
const _hoisted_16 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-normal min-w-120px flex-shrink-0" }, "Ngày sinh:", -1)
const _hoisted_18 = { class: "fw-semibold text-gray-800" }
const _hoisted_19 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-normal min-w-120px flex-shrink-0" }, "Giới tính:", -1)
const _hoisted_21 = { class: "fw-semibold text-gray-800" }
const _hoisted_22 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-normal min-w-120px flex-shrink-0" }, "Năm tốt nghiệp:", -1)
const _hoisted_24 = { class: "fw-semibold text-gray-800" }
const _hoisted_25 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-normal min-w-120px flex-shrink-0" }, "Đối tượng:", -1)
const _hoisted_27 = { class: "fw-semibold text-gray-800" }
const _hoisted_28 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-normal min-w-120px flex-shrink-0" }, "Khu vực:", -1)
const _hoisted_30 = { class: "fw-semibold text-gray-800" }
const _hoisted_31 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-normal min-w-120px flex-shrink-0" }, "Lớp 10:", -1)
const _hoisted_33 = { class: "fw-semibold text-gray-800" }
const _hoisted_34 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-normal min-w-120px flex-shrink-0" }, "Lớp 11:", -1)
const _hoisted_36 = { class: "fw-semibold text-gray-800" }
const _hoisted_37 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-normal min-w-120px flex-shrink-0" }, "Lớp 12:", -1)
const _hoisted_39 = { class: "fw-semibold text-gray-800" }
const _hoisted_40 = { class: "text-end" }
const _hoisted_41 = {
  "data-bs-toggle": "tooltip",
  "data-bs-trigger": "hover",
  title: "Chi tiết hồ sơ"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(" Thông tin cá nhân "),
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr072.svg" })
                ])
              ])
            ]),
            _createVNode(_component_router_link, {
              to: `/danhsachungvien/${_ctx.data.id}#tab3`,
              class: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.data.amount) + " hồ sơ", 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.fmt(_ctx.data.idCard)), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.dobText), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.data.gender === true || _ctx.data.gender === 'true' ? 'Nam' : (_ctx.data.gender === false || _ctx.data.gender === 'false' ? 'Nữ' : '—')), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.fmt(_ctx.data.graduatedYear)), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.data.priorityObject == '00' ? 'Không ưu tiên' : _ctx.fmt(_ctx.data.priorityObject)), 1)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.fmt(_ctx.data.priorityArea)), 1)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.joinParts([_ctx.data['class10School.name'], _ctx.data['class10District.name'], _ctx.data['class10Province.name']])), 1)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.joinParts([_ctx.data['class11School.name'], _ctx.data['class11District.name'], _ctx.data['class11Province.name']])), 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.joinParts([_ctx.data['class12School.name'], _ctx.data['class12District.name'], _ctx.data['class12Province.name']])), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("span", _hoisted_41, [
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${_ctx.data.id}`,
                  class: "btn btn-sm btn-light-primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Chi tiết ứng viên ")
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}